export { default } from './shouldMergeBreakpoints'
export * from './shouldMergeBreakpoints'
